import { MemberCommitmentList } from '../../../components/Commitment';

export function MemberCommitments() {
  return <MemberCommitmentList />;
}
